const QuestionTypes = {
    CONOCIMIENTO: "desafioConocimiento",
    TALENTO: "desafioTalento",
    CREATIVIDAD: "desafioCreativo"
}

const QuestionTypesColor = {
    CONOCIMIENTO: '#1c98cb',
    TALENTO: '#cb1c1c',
    CREATIVIDAD: '#ffe501'
}
export { QuestionTypes, QuestionTypesColor };